import http from "../http";

export async function getBatchSettings(epId) {
  const config = {
    params: { epId: epId }
  };
  const response = await http.get(`/batch/configuration`, config);
  return response.data;
}

export async function updateBatchSettings(data, epId) {
  const config = {
    params: { epId: epId }
  };
  const response = await http.put(`/batch/configuration`, data, config);
  return response.data;
}

export async function getBatchStatus(data) {
  const response = await http.post(`/batch/job-status`, data);
  return response.data;
}
